import { Component, OnInit } from '@angular/core';
import { OpenIDConnectService } from '@services/auth/openid-connect.service';

@Component({
  selector: 'app-silent-renew-redirect',
  templateUrl: './silent-renew-redirect.component.html',
  styleUrls: ['./silent-renew-redirect.component.scss']
})
export class SilentRenewRedirectComponent implements OnInit {
  constructor(private readonly openIdConnectService: OpenIDConnectService) {}

  ngOnInit() {
    this.openIdConnectService.handleSilentCallback();
  }
}
